import { useEffect, useState } from "react";
import { useBridgeClient } from "./BridgeClientContext";
import type { ThemePayload } from "./bridge-client";

/**
 * Subscribe to host theme pushes. Returns the most recently pushed theme,
 * or `undefined` before the first push (e.g. during initial render before
 * the host has sent its first `BRIDGE_PUSH_THEME` message).
 *
 * The hook re-registers with the bridge client if the client identity changes
 * (e.g. on hot-reload of the mock host in dev), keeping state consistent.
 */
export function useBridgeTheme(): ThemePayload | undefined {
  const client = useBridgeClient();
  const [theme, setTheme] = useState<ThemePayload | undefined>(undefined);

  useEffect(() => {
    client.onTheme((payload) => setTheme(payload));
    // No cleanup needed — `onTheme` replaces the subscriber; unmounting
    // drops the hook's closure reference, preventing stale-state updates.
  }, [client]);

  return theme;
}
